
<template>
    <div>
      <div class="title-div">
        <el-row>
          <el-col :span="5" v-show="phone==='手机号'">
            {{phone}}：
             <el-input clearable v-model="form.Vphone" style="width:70%" size="mini" placeholder="请输入手机号"></el-input>
          </el-col>
          <el-col :span="5" v-show="name==='昵称'">
            {{name}}：
             <el-input clearable v-model="form.Vname" style="width:70%" size="mini" placeholder="请输入昵称"></el-input>
          </el-col>
          <el-col :span="5" v-show="column==='栏目名'">
            {{column}}：
             <el-input clearable v-model="form.Vcolumn" style="width:70%" size="mini" placeholder="请输入栏目名"></el-input>
          </el-col>
          <el-col :span="5" v-show="sex==='性别'">
            {{sex}}：
            <el-select clearable v-model="form.Vsex" size="mini" style="width:70%" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" v-show="viptype==='会员类型'">
            {{viptype}}：
            <el-select clearable v-model="form.Vviptype" size="mini" style="width:65%" placeholder="请选择">
              <el-option
                v-for="item in vip"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" v-show="state==='状态'">
            {{state}}：
            <el-select clearable v-model="form.Vstate" size="mini" style="width:70%" placeholder="请选择">
              <el-option
                v-for="item in states"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="6" v-show="month==='期刊'" style="width:40%">
            {{month}}：
            <el-date-picker
              size="mini"
              v-model="Vmonth"
              value-format="yyyy-MM"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              style="width:90%"
              >
            </el-date-picker>
          </el-col>


          <el-col :span="5" v-show="periodical==='期刊'">
            {{periodical}}：
            <el-select clearable v-model="form.Vperiodical" size="mini" style="width:70%" placeholder="请选择">
              <el-option
                v-for="item in periodicalarrs"
                :key="item.id"
                :label="item.periodicalDate"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" v-show="headline==='标题'">
            {{headline}}：
             <el-input clearable v-model="form.Vheadline" style="width:70%" size="mini" placeholder="请输入标题"></el-input>
          </el-col>
          <el-col :span="5" v-show="author==='作者'">
            {{author}}：
             <el-input clearable v-model="form.Vauthor" style="width:70%" size="mini" placeholder="请输入作者"></el-input>
          </el-col>
          <el-col :span="5" v-show="antistop==='内容'">
            {{antistop}}：
             <el-input clearable v-model="form.Vantistop" style="width:70%" size="mini" placeholder="请输入内容"></el-input>
          </el-col>

          <el-col :span="5" v-show="role==='角色'">
            {{role}}：
            <el-select clearable v-model="form.Vrole" size="mini" style="width:70%" placeholder="请选择">
              <el-option
                v-for="item in roles"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
                >
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="5" v-show="rolename==='角色名'">
            {{rolename}}：
             <el-input clearable v-model="form.Vrolename" style="width:70%" size="mini" placeholder="请输入角色名"></el-input>
          </el-col>

          <el-col :span="5" v-show="accountnumber==='账号'">
            {{accountnumber}}：
             <el-input clearable v-model="form.Vaccountnumber" style="width:70%" size="mini" placeholder="请输入账号"></el-input>
          </el-col>

          <el-col :span="5" v-show="loginmethod==='登录方式'">
            {{loginmethod}}：
            <el-select clearable v-model="form.Vloginmethod" size="mini" style="width:65%" placeholder="请选择">
              <el-option
                v-for="item in methodarrs"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="5" v-show="dictionaries==='字典名'">
            {{dictionaries}}：
             <el-input clearable v-model="form.Vdictionaries" style="width:70%" size="mini" placeholder="请输入字典名"></el-input>
          </el-col>

          <el-col :span="5" v-show="type==='类型'">
            {{type}}：
             <el-input clearable v-model="form.Vtype" style="width:70%" size="mini" placeholder="请输入类型"></el-input>
          </el-col>

          <el-col :span="5" v-show="dictionariesstates==='状态'">
            {{dictionariesstates}}：
            <el-select clearable v-model="form.Vdictionariesstates" size="mini" style="width:70%" placeholder="请选择">
              <el-option
                v-for="item in dictionariesStatesArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="5" v-show="jurisdictionname==='权限名'">
            {{jurisdictionname}}：
             <el-input clearable v-model="form.Vjurisdictionname" style="width:70%" size="mini" placeholder="请输入权限名"></el-input>
          </el-col>

          <el-col :span="6" v-show="jurisdictionType==='权限类别搜索'">
            {{jurisdictionType}}：
            <el-select clearable v-model="form.VjurisdictionType" size="mini" style="width:65%" placeholder="请选择">
              <el-option
                v-for="item in jurisdictionTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="1" style="text-align: center;">
            <el-button type="primary" size="mini" @click="inquire()">查询</el-button>
          </el-col>
          <el-col :span="1" style="float: left;margin-left:0.2rem;text-align: center;" v-if="isback">
            <el-button type="primary" size="mini" @click="inback()">返回</el-button>
          </el-col>
          <el-col :span="3" style="float: right;text-align: center;" v-if="isbtn">
            <el-button type="primary" size="mini" @click="btn()" :icon="icon">{{btnname}}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
</template>
<script>
export default {
  name: "Title",
  props: {
    phone:{
      type:String
    },
    name:{
      type:String
    },
    sex:{
      type:String
    },
    viptype:{
      type:String
    },
    state:{
      type:String
    },
    month:{
      type:String
    },
    column:{
      type:String
    },
    isbtn:{
      type:Boolean,
      default:false
    },
    isback:{
      type:Boolean,
      default:false
    },
    vip:{
      type:Array,
    },
    periodicalarrs:{
      type:Array
    },
    roles:{
      type:Array
    },
    methodarrs:{
      type:Array
    },
    btnname:{
      type:String
    },
    icon:{
      type:String
    },
    headline:{
      type:String
    },
    author:{
      type:String
    },
    antistop:{
      type:String
    },
    periodical:{
      type:String
    },
    role:{
      type:String
    },
    rolename:{
      type:String
    },
    accountnumber:{
      type:String
    },
    loginmethod:{
      type:String
    },
    dictionaries:{
      type:String
    },
    type:{
      type:String
    },
    dictionariesstates:{
      type:String
    },
    jurisdictionname:{
      type:String
    },
    jurisdictionType:{
      type:String
    },
    Vmonth:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      jurisdictionTypeArr:[{
          value: ' ',
          label: '全部'
        },{
          value: '0',
          label: '菜单'
        }, {
          value: '1',
          label: '按钮'
        }],
        options: [{
          value: ' ',
          label: '全部'
        },{
          value: '1',
          label: '男'
        }, {
          value: '2',
          label: '女'
        }],
        dictionariesStatesArr: [{
          value: ' ',
          label: '全部'
        },{
          value: '0',
          label: '无效'
        }, {
          value: '1',
          label: '有效'
        }],
        states: [{
          value: ' ',
          label: '全部'
        }, {
          value: '0',
          label: '待审核'
        }, 
        // {
        //   value: '1',
        //   label: '通过'
        // },
         {
          value: '2',
          label: '驳回'
        }],
        form:{
          Vsex: '', // 男女
          Vphone: '', // 手机号
          Vname: '', // 昵称
          Vviptype: '', // 会员类别
          Vstate: '', // 状态
          Vcolumn: '', // 栏目名
          // Vmonth:[], //月份
          Vheadline:'', //标题
          Vauthor:'',//作者
          Vantistop:'',//内容
          Vperiodical:'',//期刊id
          Vrole:'',//角色
          Vrolename:'',//角色名
          Vaccountnumber:'',//账号
          Vloginmethod:'',//登录方式
          Vdictionaries:'',//字典名
          Vtype:'',//类型
          Vdictionariesstates:'',//字典状态
          Vjurisdictionname:'',//权限名
          VjurisdictionType:'',//权限类别搜索
        }
    }
  },
  watch:{
    Vmonth(value){
      if(value == null){
        // this.form.Vmonth = ['','']
        this.Vmonth = ['','']
      }
      //监听值得变化 将值传出去
      this.$emit('change', this.Vmonth)
    },

  },
  methods(){

  },
  computed: {
    // Vmonth(){
    //   return this.Vmonth
    // }
  },
  methods: {
    inquire () {
      this.$emit('gotoinquire', this.form)
      /* this.form.Vsex = '';
      this.form.Vphone = '';
      this.form.Vname = '';
      this.form.Vviptype = '';
      this.form.Vstate = '';
      this.form.Vcolumn = ''; */
    },
    inback () {
      this.$emit('goback')
    },
    btn(){
      this.$emit('gotobtn')
    },
  }
}
</script>
<style lang="scss" scoped>
.title-div{
  background: #fff;
  padding: 15px 20px;
  top:0; //解决头部块被挤上去的问题
}
/deep/.el-date-editor .el-range-separator{
  width:10%;
}
.el-date-editor .el-range-separator{
  width:10%;
}
</style>